import mapStyle from '../../components/Map/mapStyle.json';

// клик по аккардеону
$(".js-contacts-item-top").click(function () {
    let $el = $(this);
    $el.parents(".contacts-item").toggleClass("_active");

    if ($el.parents(".contacts-item").hasClass("_active")) {
        $el.siblings(".contacts-item-content").slideDown(100);
    } else {
        $el.siblings(".contacts-item-content").slideUp(100);
    }
});

if (App.H.hasClass("page-contacts")) {
    if (App.W.width() < 768) {
        App.H.on("click", ".js-filter-close", function () {
            $(this).closest(".js-dropdown").removeClass("_opened");
        });
    }

    // App.H.on("click", ".js-filter-open", function () {
    //     if ($(".js-catalog-wrapper").hasClass("_filter-opened")) {
    //         $(".js-catalog-wrapper").removeClass("_filter-opened");
    //         App.lockScroll.unlock();
    //     } else {
    //         $(".js-catalog-wrapper").addClass("_filter-opened");
    //         App.lockScroll.lock();
    //     }
    // });
    // App.H.on("click", ".js-filter-close", function () {
    //     $(".js-catalog-wrapper").removeClass("_filter-opened");
    //     App.lockScroll.unlock();
    // });
}

// Инициализация большой карты
async function initMap(rootDom) {
    if (!rootDom) return;

    const LOCATION = {
        center: [37.64, 55.76],
        zoom: 4
    };
    const ZOOM_RANGE = {
        min: 3,
        max: 19
    };

    await ymaps3.ready;

    ymaps3.import.registerCdn(
        'https://cdn.jsdelivr.net/npm/{package}',
        [
            '@yandex/ymaps3-clusterer@0.0.1'
        ]
    );

    const {
        YMap,
        YMapDefaultSchemeLayer,
        YMapDefaultFeaturesLayer,
        YMapMarker
    } = ymaps3;

    const {
        YMapClusterer,
        clusterByGrid
    } = await ymaps3.import('@yandex/ymaps3-clusterer');

    const features = window.mapCollections.features;

    // Иницилиазируем карту
    const map = new YMap(
        rootDom,
        {
            location: LOCATION,
            zoomRange: ZOOM_RANGE
        }
    );

    map.addChild(new YMapDefaultSchemeLayer({
        // Стилизация карты
        customization: mapStyle
    }));
    map.addChild(new YMapDefaultFeaturesLayer());

    // Рендер пина
    const createMarker = (feature) => {
        const element = document.createElement('div');
        element.className = 'pin';

        element.addEventListener('click', () => {
            map.update({
                location: {
                    center: feature.geometry.coordinates,
                    duration: 300
                }
            });

            showBalloon(feature);
        });

        return new YMapMarker(
            {
                coordinates: feature.geometry.coordinates
            },
            element
        );
    };

    // Рендер кластера
    const createCluster = (coordinates, features) => {
        const element = document.createElement('div');

        element.className = 'cluster';
        element.innerHTML = features.length;

        element.onclick = () => {
            const ZOOM_DURATION = 500;

            const lngs = features.map(
                f => f.geometry.coordinates[0]
            );
            const lats = features.map(
                f => f.geometry.coordinates[1]
            );
            const bounds = [
                [Math.min(...lngs), Math.min(...lats)],
                [Math.max(...lngs), Math.max(...lats)]
            ];

            map.update({
                // Задаём отступы чтобы поместились крайние пины
                margin: [100, 100, 100, 100],
                location: {
                    bounds: bounds,
                    duration: ZOOM_DURATION
                }
            });

            // Убираем отступы чтобы отрисовались крайние пины после анимации приближения
            setTimeout(() => {
                map.update({
                    margin: [0, 0, 0, 0]
                });
            }, ZOOM_DURATION + 50);
        };

        return new YMapMarker(
            {
                coordinates
            },
            element
        );
    };

    // Карточка пина
    let currentBalloon = null;

    const showBalloon = (feature) => {
        if (currentBalloon) {
            map.removeChild(currentBalloon);
        }

        const balloon = document.createElement('div');

        balloon.className = 'balloon';

        balloon.innerHTML = `
            <div class="balloon-title">
                ${feature.properties.balloonContentHeader}
            </div>
            <div class="balloon-text">
                ${feature.properties.balloonContentBody}
            </div>
            <div class="balloon-footer">
                ${feature.properties.balloonContentFooter}
            </div>
            <button class="balloon-close">✕</button>
        `;

        balloon.querySelector('.balloon-close').addEventListener('click', closeBalloon);

        currentBalloon = new YMapMarker(
            {
                coordinates: feature.geometry.coordinates
            },
            balloon
        );

        map.addChild(currentBalloon);
    };

    function closeBalloon() {
        if (!currentBalloon) {
            return;
        }

        map.removeChild(currentBalloon);

        currentBalloon = null;
    }

    // Кластеризатор
    const clusterer = new YMapClusterer({
        method: clusterByGrid({gridSize: 64}),
        features,
        marker: createMarker,
        cluster: createCluster
    });

    map.addChild(clusterer);
}

const elementBigMap = document.getElementById("big-map");

if (elementBigMap) {
    initMap(elementBigMap);
}
